export var DEFAULT_LOCALE = 'en-GB';
export var LANGUAGE_QUERY_PARAM = 'lang';